import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface PersonMobilisation {
  id: string;
  name: string;
}

/**
 * Day-mobilisation memberships keyed by person_id, for the people
 * admin list. People with no entry belong to no mobilisation day
 * (onboarding-only, or mis-allocated and in need of repair). The
 * onboarding cohort is excluded server-side.
 */
export function usePeopleMemberships() {
  return useQuery({
    queryKey: ['people-memberships'],
    queryFn: async () =>
      (
        await api<{ memberships: Record<string, PersonMobilisation[]> }>(
          '/api/admin/people/_memberships',
        )
      ).memberships,
  });
}
